import { useState } from 'react';
import { X } from 'lucide-react';
import { PARAPHEUR_COPY } from '../../services/signature/parapheurCopy';

interface Props {
  onConfirm: (password: string) => void;
  onClose: () => void;
  pending: boolean;
  error?: string | null;
  title?: string;
  hint?: string;
  cta?: string;
}

export function VisaReauthDialog({
  onConfirm, onClose, pending, error,
  title = PARAPHEUR_COPY.confirmVisa,
  hint = PARAPHEUR_COPY.reauthHint,
  cta = PARAPHEUR_COPY.ctaSign,
}: Props) {
  const [password, setPassword] = useState('');
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4" onClick={onClose}>
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md" onClick={(e) => e.stopPropagation()}>
        <header className="flex items-center justify-between px-5 py-4 border-b border-neutral-200">
          <h3 className="font-heading text-lg font-semibold text-cime-text-primary">{title}</h3>
          <button type="button" onClick={onClose} className="text-neutral-400 hover:text-neutral-700">
            <X className="w-4 h-4" />
          </button>
        </header>
        <form
          className="px-5 py-4 space-y-3"
          onSubmit={(e) => {
            e.preventDefault();
            if (!password) return;
            onConfirm(password);
          }}
        >
          <p className="text-sm text-neutral-600">
            {hint}
          </p>
          <input
            autoFocus
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Mot de passe"
            className="w-full border border-neutral-200 rounded-md px-3 py-2 text-sm"
          />
          {error ? <p className="text-sm text-red-600">{error}</p> : null}
          <footer className="flex items-center justify-end gap-2 pt-1">
            <button
              type="button"
              onClick={onClose}
              className="text-sm px-3 py-1.5 text-cime-text-muted hover:text-neutral-900"
            >
              Annuler
            </button>
            <button
              type="submit"
              disabled={!password || pending}
              className="text-sm px-3 py-1.5 rounded-md bg-cime-primary text-white hover:opacity-90 disabled:opacity-40"
            >
              {cta}
            </button>
          </footer>
        </form>
      </div>
    </div>
  );
}
